import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { MainRoutes, AuthRoutes } from './routes'

import { MainLayout } from './layouts/MainLayout'
import AuthLayout from './layouts/AuthLayout'
import NotFound from './components/NotFound'
import { useEffect, useState } from 'react'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
// Import Material UI components
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
  Typography,
} from '@mui/material'
import UpdateIcon from '@mui/icons-material/Update'

function App() {
  const [updateAvailable, setUpdateAvailable] = useState(false)
  const [waitingWorker, setWaitingWorker] =
    useState<ServiceWorkerRegistration | null>(null)
  const [showUpdateDialog, setShowUpdateDialog] = useState(false)

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        setUpdateAvailable(true)
        setWaitingWorker(registration)
        setShowUpdateDialog(true)
      },
    })
  }, [])

  const handleRefresh = () => {
    setShowUpdateDialog(false)

    if (waitingWorker && waitingWorker.waiting) {
      // Send skip-waiting message
      waitingWorker.waiting.postMessage({ type: 'SKIP_WAITING' })
    }

    // Add event listener for controlling change
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // Only reload once
      if (window.refreshing) return
      window.refreshing = true
      window.location.reload()
    })
  }

  const handleClose = () => {
    setShowUpdateDialog(false)
  }

  return (
    <>
      {/* Update Dialog */}
      <Dialog
        open={showUpdateDialog}
        onClose={handleClose}
        aria-labelledby="update-dialog-title"
        aria-describedby="update-dialog-description"
      >
        <DialogTitle id="update-dialog-title">
          <Typography
            variant="h6"
            component="div"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <UpdateIcon sx={{ mr: 1 }} />
            Update Available
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="update-dialog-description">
            A new version of this application is available. Please update to the
            latest version for the best experience.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Later
          </Button>
          <Button
            onClick={handleRefresh}
            variant="contained"
            color="primary"
            autoFocus
          >
            Update Now
          </Button>
        </DialogActions>
      </Dialog>

      {/* Fallback notification if dialog is dismissed */}
      <Snackbar
        open={updateAvailable && !showUpdateDialog}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity="info"
          action={
            <Button color="inherit" size="small" onClick={handleRefresh}>
              UPDATE
            </Button>
          }
        >
          New version available
        </Alert>
      </Snackbar>

      <Router>
        <Routes>
          <Route element={<MainLayout />}>
            {MainRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path as string}
                element={route.element}
              />
            ))}
          </Route>
          <Route element={<AuthLayout />}>
            {AuthRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path as string}
                element={route.element}
              />
            ))}
          </Route>
          <Route path={'*'} element={<NotFound />} />
        </Routes>
      </Router>
    </>
  )
}

// Add this to your global.d.ts or directly in this file
declare global {
  interface Window {
    refreshing?: boolean
  }
}

export default App
